/**
 * Route for `export-permission-csv-xlsx-per-role`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ExportPermissionCsvXlsxPerRolePage } from "../features/export-permission-csv-xlsx-per-role/ExportPermissionCsvXlsxPerRolePage";

export const exportPermissionCsvXlsxPerRoleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/export-permission-csv-xlsx-per-role",
	component: ExportPermissionCsvXlsxPerRolePage,
});

export default exportPermissionCsvXlsxPerRoleRoute;
